import { useMemo } from 'react';

import {
  BulkModuleDefinition,
  ChannelForModuleCheck,
} from '../registry/bulkModuleRegistry';

type PreviewResult = {
  totalTargets: number;
  alreadyEnabledIds: string[];
  toEnableIds: string[];
};

/**
 * Derives preview counts synchronously from already-loaded channel data.
 *
 * Because the selection queries fetch module settings alongside the channel
 * list, no separate API call is needed — the enabled/disabled split is
 * computed in a single `useMemo` pass over the selected channels.
 */
export function useBulkChannelModulePreview(
  selectedChannels: ChannelForModuleCheck[],
  moduleDefinition: BulkModuleDefinition
): PreviewResult {
  return useMemo(() => {
    const alreadyEnabledIds: string[] = [];
    const toEnableIds: string[] = [];

    for (const ch of selectedChannels) {
      if (moduleDefinition.isAlreadyEnabled(ch)) {
        alreadyEnabledIds.push(ch._id);
      } else {
        toEnableIds.push(ch._id);
      }
    }

    return {
      totalTargets: selectedChannels.length,
      alreadyEnabledIds,
      toEnableIds,
    };
  }, [selectedChannels, moduleDefinition]);
}
